/** Mirrors the Cognito pool password policy (min 8 + upper + lower + number + symbol) so
 *  every create-password UI gates identically to what the server will accept. */
export const PASSWORD_RULES: { label: string; test: (v: string) => boolean }[] = [
  { label: 'At least 8 characters', test: (v) => v.length >= 8 },
  { label: 'An uppercase letter', test: (v) => /[A-Z]/.test(v) },
  { label: 'A lowercase letter', test: (v) => /[a-z]/.test(v) },
  { label: 'A number', test: (v) => /[0-9]/.test(v) },
  { label: 'A symbol', test: (v) => /[^A-Za-z0-9]/.test(v) },
]

export const isPasswordCompliant = (value: string): boolean =>
  PASSWORD_RULES.every((rule) => rule.test(value))

/** Shared so every confirm-password field reports a mismatch identically. */
export const PASSWORD_MISMATCH_MESSAGE = 'Passwords do not match'
